import StringManager from '../StringManager';
export const strings = new StringManager();
export default strings;



// WEBPACK FOOTER //
// ./node_modules/@ps/payscale-shared-ui/lib/Strings/index.js